import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { useTranslation } from 'react-i18next';

type Props = {
  organizationName?: string;
  providerName?: string;
};

export const LalSegmentOwnerSection = ({ organizationName, providerName }: Props) => {
  const { t } = useTranslation();

  return (
    <FormSection divider title={t('Owner')} data-test="owner-details">
      <FieldDetails title={t('Organization')} value={organizationName} />
      <FieldDetails title={t('Provider')} value={providerName} />
    </FormSection>
  );
};
